// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOctRotationY_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V23.9984H17.1279V21.9985H2V1.99987H22V13.4327H24V0H0ZM5.02441 11.407C5.21315 9.20416 6.43995 7.12594 8.5 5.93664C11.848 4.00378 16.1292 5.15083 18.0622 8.49865L18.9282 7.99868L18.6962 11.5965L15.4641 9.99855L16.3301 9.49858C14.9494 7.10728 11.8915 6.28796 9.5 7.66858C8.52501 8.23145 7.81132 9.0731 7.4015 10.0347L5.02441 11.407ZM15.4501 18.0887C12.1096 19.9816 7.86124 18.8294 5.93782 15.4982L5.0718 15.9982L5.30385 12.4003L8.5359 13.9983L7.66987 14.4983C9.05058 16.8896 12.1085 17.7089 14.5 16.3283L14.5061 16.3247L15.4501 18.0887ZM20.1479 18.8043L21.7919 15.4326H23.9999L21.1679 20.6642V24H19.1279V20.7242L16.2959 15.4326H18.5159L20.1479 18.8043Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedOctRotationY is a generated icon component.
 */
let IconMedOctRotationY = IconMedOctRotationY_1 = class IconMedOctRotationY extends IconBaseElement {
    render() {
        return html `${IconMedOctRotationY_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOctRotationY.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedOctRotationY = IconMedOctRotationY_1 = __decorate([
    customElement('zui-icon-med-oct-rotation-y')
], IconMedOctRotationY);
export { IconMedOctRotationY };
